module.exports = __webpack_public_path__ + "static/first_user_image4-96d6302b314b1a4cba7d20332b725b95.jpg";